import {
    ExperimentParticipationQueryKey,
    ExperimentQueryKey,
    ExperimentQueryOptions,
} from '@data/queries/experiment/types'
import { getInitialQueryData } from '@data/queries/initialData/getInitialQueryData'
import experimentMapSchema from '@data/schemas/experimentMap'

const mapper = (data: Json) => experimentMapSchema.validateSync(data)
const experimentMap = getInitialQueryData<TExperimentMap>('experiments', mapper)

function getInitialData(experimentName: TExperimentName): TExperimentMap | undefined {
    if (!experimentMap || !experimentMap[experimentName]) {
        return
    }

    return {
        [experimentName]: experimentMap[experimentName],
    }
}

/**
 * Includes the common options for experiment query hooks that can be determined we need to call the hook.
 */
export function getPartialExperimentQueryOptions<QueryKey extends ExperimentQueryKey | ExperimentParticipationQueryKey>(
    experimentName: TExperimentName,
    options?: ExperimentQueryOptions<QueryKey>
): Omit<ExperimentQueryOptions<QueryKey>, 'enabled'> {
    return {
        staleTime: Infinity,
        refetchOnMount: false,
        ...options,
        meta: {
            silenceErrors: true,
            ...options?.meta,
        },
        initialData: getInitialData(experimentName),
    }
}
